/**
 * Compares two arrays of strings for equality.
 * Two arrays are considered equal if they have same lengths and the
 * same strings at the same indexes. If any array is undefined, it will return false.
 *
 * @param {string[] | undefined} arr1 - The first array to compare.
 * @param {string[] | undefined} arr2 - The second array to compare.
 * @returns {boolean} True if arrays are equal, false otherwise.
 */
export const arraysAreEqual = (arr1?: string[], arr2?: string[]): boolean => {
  if (arr1 === undefined || arr2 === undefined) {
    return false;
  }

  return arr1.length === arr2.length && arr1.every((value, index) => value === arr2[index]);
};
